/** Which numbers the report shows: the entered inputs (full), or the inputs less their adjustments. */
export type WireframeReportView = 'full' | 'adjusted';

/**
 * The Finance report's query key, per half (both views). The Wireframe Data
 * admin page invalidates it after saving inputs, so neither view ever shows
 * totals from before the edit.
 */
export const wireframeReportQueryKey = (timeframe: string) => ['admin-wireframe-report', timeframe];

/** One view of the half's report, cached apart from the other. */
export const wireframeReportViewQueryKey = (timeframe: string, view: WireframeReportView) => [
  ...wireframeReportQueryKey(timeframe),
  view,
];

/**
 * Whether a query key is one of the half's report views, so one half's report
 * never stands in for another's.
 */
export const isSameHalfReportKey = (key: readonly unknown[], timeframe: string) => {
  const half = wireframeReportQueryKey(timeframe);
  return key.length > half.length && half.every((segment, index) => key[index] === segment);
};
